// export const formatNumber = (value, decimalPlaces = 2) => {
//     if (isNaN(value)) return "0";
//     return Number(value).toLocaleString("en-US", {
//         minimumFractionDigits: decimalPlaces,
//         maximumFractionDigits: decimalPlaces,
//     });
// };
import NoPropertyImg from "../images/no_property.png";
import dummyPerson from "../images/dummy_person.png";

export const minOptions = [
    { value: 0, label: "0" },
    { value: 200000, label: "200,000" },
    { value: 225000, label: "225,000" },
    { value: 250000, label: "250,000" },
    { value: 275000, label: "275,000" },
    { value: 300000, label: "300,000" },
    { value: 325000, label: "325,000" },
    { value: 350000, label: "350,000" },
    { value: 375000, label: "375,000" },
    { value: 400000, label: "400,000" },
];

export const maxOptions = [
    { value: 0, label: "Any" },
    { value: 400000, label: "400,000" },
    { value: 425000, label: "425,000" },
    { value: 450000, label: "450,000" },
    { value: 475000, label: "475,000" },
    { value: 500000, label: "500,000" },
    { value: 525000, label: "525,000" },
    { value: 550000, label: "550,000" },
    { value: 575000, label: "575,000" },
    { value: 600000, label: "600,000" },
];

export const minAreaOption = [
    { value: 0, label: "0" },
    { value: 800, label: "800" },
    { value: 1000, label: "1000" },
    { value: 1500, label: "1500" },
    { value: 2000, label: "2000" },
    { value: 2500, label: "2500" },
    { value: 3000, label: "3000" },
    { value: 3500, label: "3500" },
    { value: 4000, label: "4000" },
    { value: 4500, label: "4500" },
];
export const maxAreaOption = [
    { value: "Any", label: "Any" },
    { value: 1000, label: "1000" },
    { value: 1500, label: "1500" },
    { value: 2000, label: "2000" },
    { value: 2500, label: "2500" },
    { value: 3000, label: "3000" },
    { value: 3500, label: "3500" },
    { value: 4000, label: "4000" },
    { value: 4500, label: "4500" },
];
export const formatNumber = (value, decimalPlaces = 2) => {
    if (isNaN(value)) return "0";
    const formattedValue = Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimalPlaces,
    });
    if (formattedValue.includes(".") && formattedValue.split(".")[1] === "00") {
        return formattedValue.split(".")[0];
    }
    return formattedValue;
};

export const regulatoyinfo = [
    // { authorityType: "DED", tooptipText: "The licence number issued by the Department of Economic Development" },
    // { authorityType: "RERA", tooptipText: "Licence issued by Dubai's Real Estate Regulatory Agency." },
    { name: "DED", authorityType: "DED", fullName: "Department of Economic Development", tooltip: "The licence number issued by the Department of Economic Development.", isActive: true },
    { name: "RERA", authorityType: "RERA", fullName: "Real Estate Regulatory Agency", tooltip: "Licence issued by Dubai Real Estate Regulatory Agency.", isActive: true },
    { name: "ADM", authorityType: "ADM", fullName: "Abu Dhabi Municipality", tooltip: "This is the agent license number issued by the Abu Dhabi Department of Economic Development.", isActive: true },
    { name: "ORN", authorityType: "ORN", fullName: "Office Registration Number", tooltip: "The Office Registration Number for each RERA-registered real estate company in Dubai.", isActive: true },
    // { name: "NRN", type: "NRN", fullName: null, tooltip: null, isActive: false },
];
export const formatDateToShortMonth = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

// export const getQuarter = (dateStr) => {
//     const date = new Date(dateStr);
//     const month = date.getMonth(); // 0 = Jan, 4 = May
//     const quarter = Math.floor(month / 3) + 1;
//     return `Q${quarter} ${date.getFullYear()}`;
// }; // Output: "Q2 2025"

export const getQuarter = (dateStr) => {
    // if (!dateStr) return "";
    // const [datePart] = dateStr.split(" ");
    // const [day, month, year] = datePart.split("-").map(Number);
    // const date = new Date(year, month - 1, day);
    // if (isNaN(date.getTime())) {
    //     return "";
    // }
    // const quarter = Math.floor(date.getMonth() / 3) + 1;
    // return `Q${quarter} ${date.getFullYear()}`;
     if (!dateStr) return "";
    let date;
    if (dateStr instanceof Date) {
        date = dateStr;
    }
    else if (typeof dateStr === "string") {
        if (dateStr.includes("-") && dateStr.indexOf("-") === 2) {
            const [day, month, rest] = dateStr.split("-");
            const [year, time, meridian] = rest.split(" ");
            const formatted = `${year}-${month}-${day} ${time || ""} ${meridian || ""}`;
            date = new Date(formatted);
        } else {
            date = new Date(dateStr);
        }
    }
    else {
        return "Invalid Date";
    }
    if (isNaN(date)) return "Invalid Date";
    const quarter = Math.floor(date.getMonth() / 3) + 1;
    return `Q${quarter} ${date.getFullYear()}`;
};

export const convertMonth = (dateString) => {
    const date = new Date(dateString);
    date.setFullYear(date.getFullYear() - 1);
    const options = { year: "numeric", month: "long" };
    return date.toLocaleDateString("en-US", options);
}; // "April 2024"

export const getLastPathParam = () => {
    try {
        let value = null;
        const sPageURL = window.location.href;
        const indexOfLastSlash = sPageURL.lastIndexOf("/");
        if (indexOfLastSlash > 0 && sPageURL.length - 1 !== indexOfLastSlash) {
            value = sPageURL.substring(indexOfLastSlash + 1);
        }
        return value;
    } catch (e) {
        return null;
    }
};

export const formatShortNumber = (value) => {
    const units = ["", "K", "M", "B", "T", "P", "E"]; // Can add more as needed
    let unitIndex = 0;
    while (value >= 1000 && unitIndex < units.length - 1) {
        value /= 1000;
        unitIndex++;
    }
    return value % 1 === 0 ? `${value}${units[unitIndex]}` : `${value.toFixed(2)}${units[unitIndex]}`;
};
export const formatShortNumberTwo = (input) => {
    let value = Number(input); // Convert input to a number
    if (isNaN(value)) return "NaN"; // Handle invalid input
    const units = ["", "K", "M", "B", "T", "P", "E"];
    let unitIndex = 0;
    while (value >= 1000 && unitIndex < units.length - 1) {
        value /= 1000;
        unitIndex++;
    }
    const formatted = parseFloat(value.toFixed(1)); // One decimal max
    return `${formatted}${units[unitIndex]}`;
};
export const fatchAreaFind = (projectUnits = [], areaUnits = []) => {
    return projectUnits.map((unit) => {
        const matchedUnit = areaUnits.find((area) => area.uId === unit?.dimension?.unitAreaUnitId);
        return {
            ...unit,
            unitNameResolved: matchedUnit ? matchedUnit.unit : null,
        };
    });
};
export const onKeyDown = (e, flag) => {
    if (e.key === "e" || e.key === "E" || (!flag && e.key === ".") || e.key === "-" || e.key === "+") {
        e.preventDefault();
    }
};

export const rentFqcyARY = [
    { id: 1, name: "Yearly", type: "yearly" },
    { id: 2, name: "Monthly", type: "monthly" },
    { id: 3, name: "Weekly", type: "weekly" },
    { id: 4, name: "Daily", type: "daily" },
    // { id: 5, name: "Any", type: "any" },
];
export const quarterARY = [{ name: "Q1 2026" }, { name: "Q2 2026" }, { name: "Q3 2026" }, { name: "Q4 2026" }, { name: "Q1 2027" }, { name: "Q2 2027" }, { name: "Q3 2027" }, { name: "Q4 2027" }, { name: "Q1 2028" }, { name: "Q2 2028" }];
export const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
};

export const convertToSlug = (str) => {
    return str
        ?.toLowerCase() // Convert to lowercase
        ?.replace(/\s+/g, "-") // Replace spaces with hyphens
        ?.replace(/[^\w\-]+/g, "") // Remove non-alphanumeric characters except hyphens
        ?.replace(/\-\-+/g, "-") // Replace multiple hyphens with one
        ?.trim("-"); // Remove hyphen from start and end if any
};
// Function to extract the last number
export const extractLastNumber = (text) => {
    const match = text.match(/(\d+)$/); // Matches the last number in the string
    return match ? match[0] : null;
};
export const sendWhatsAppMessage = (phoneNumber, defaultMessage) => {
    const encodedMessage = encodeURIComponent(defaultMessage);
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
};

export const onError = ({ currentTarget }) => {
    currentTarget.onerror = null;
    currentTarget.src = `${NoPropertyImg}`;
};

export const onAgtError = ({ currentTarget }) => {
    currentTarget.onerror = null;
    currentTarget.src = `${dummyPerson}`;
};
